import { Middleware } from 'redux';
import { parseJwt } from '../../helpers/jwt';
import { getFromLocalStorage, StorageKey } from '../../helpers/localstorage';
import { AppDispatch } from '../core';
import { APP_START } from '../general/general.actions';
import {
  setAccessToken,
  setIsEmailConfirmed,
  setRefreshToken,
} from '../user/user.actions';

export const mainMiddleware: Middleware =
  ({ dispatch }: any) =>
  (next) =>
  async (action) => {
    switch (action.type) {
      case APP_START: {
        initApp(dispatch);
        next(action);
        break;
      }
      default: {
        next(action);
      }
    }
  };

const initApp = (dispatch: AppDispatch) => {
  const accessToken = getFromLocalStorage(StorageKey.AccessToken);
  const refreshToken = getFromLocalStorage(StorageKey.RefreshToken);

  if (accessToken) {
    const jwtData = parseJwt(accessToken);
    dispatch(setIsEmailConfirmed(!jwtData.nec));
  }

  dispatch(setAccessToken(accessToken));
  dispatch(setRefreshToken(refreshToken));
};
